<div [hidden]="!active"
     
    class="style-height-width-100">
    <ng-content></ng-content>
</div>